import type { InternalAxiosRequestConfig, AxiosError } from 'axios';
import { cookie } from '@/presentation/index';

const onRequestError = (error: AxiosError): Promise<never> => {
	return Promise.reject(error);
};

const setTokenInHeaders = (config: InternalAxiosRequestConfig): void => {
	const tempToken = cookie.get('temp-token');
	const accessToken = cookie.get('access-token');
	const refreshToken = cookie.get('refresh-token');

	const token = accessToken || tempToken || refreshToken || '';
	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}
};

const onRequest = (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
	setTokenInHeaders(config);
	return Promise.resolve(config);
};

export { onRequest, onRequestError };
